var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"filter",class:{'active': _vm.isActive},on:{"click":_vm.changeStatus}},[_c('i',{staticClass:"icon-plus"}),_c('span',[_vm._v(_vm._s(_vm.filterElement.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }